import { useState, useEffect } from 'react';
import { getURLParameter } from '../../utils/CommonUtil';

export default function SwitchSortType({ types }) {
    const [activeType, setActiveType] = useState(null);

    useEffect(() => {
        setActiveType(getURLParameter('sort'));
    }, []);

    return (
        <div className="redesign-pills" id="switch-sort-type">
            {types.map((item, index) => {
                const sortParam = item.href.includes('sort=')
                    ? item.href.split('sort=')[1].split('&')[0]
                    : null;
                const isActive = sortParam
                    ? activeType === sortParam
                    : (!activeType && item.default);
                return (
                    <a
                        key={index}
                        href={item.href}
                        className={`redesign-pill${isActive ? ' active' : ''}`}
                    >
                        {item.name}
                    </a>
                );
            })}
        </div>
    );
}
